import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const supportManifestRoutes: ManifestRouteDefinition[] = [
  {
    key: 'support',
    path: '/support',
    apiCalls: [],
    subFeatures: [
      {
        key: 'support',
        label: 'Support',
        apiCalls: [],
      },
    ],

    lazyComponent: () =>
      import('@/features/support/pages/Support/Support').then((m) => ({
        default: m.default,
      })),
  },
]
